import { render, staticRenderFns } from "./CategoryAutoComplete.vue?vue&type=template&id=5870d156&"
import script from "./CategoryAutoComplete.vue?vue&type=script&lang=ts&"
export * from "./CategoryAutoComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5870d156')) {
      api.createRecord('5870d156', component.options)
    } else {
      api.reload('5870d156', component.options)
    }
    module.hot.accept("./CategoryAutoComplete.vue?vue&type=template&id=5870d156&", function () {
      api.rerender('5870d156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CategoryAutoComplete.vue"
export default component.exports